export default "__VITE_ASSET__BHFotDgw__"